<div class="comp-history">
  <button pButton *ngIf="!noShowButton"
          (click)="onClickShowModHistory($event,op, actualTarget)" class="icon-action" icon="fa fa-eye"></button>
  <label #actualTarget> </label>
  <p-overlayPanel #op [showCloseIcon]="true" [style]="{'max-width':'900px','width':'100%'}" [dismissable]="true"
                  (onHide)="onHideOverlayPanel($event)">
    <app-data-table [columns]="tableColumns" [value]="modHistories" sortField="modifiedOn" [disableSearch]="true"
                    [emptyMessageTemplate]="emptyMessageTemplate">
      <ng-template #emptyMessageTemplate let-columns="columns">
        <tr>
          <td [attr.colspan]="columns.length">
            No History Available, Enter Mod to the entry
          </td>
        </tr>
      </ng-template>
    </app-data-table>

  </p-overlayPanel>
</div>
